if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Returns the current URL locale prefix (e.g. "/lv") or empty string
      // for the primary locale. Used to keep cart routes in the same language
      // as the page the user is currently on, regardless of what the
      // server-rendered window.routes.cart_url contains.
      getLocalePrefix() {
        const path = window.location.pathname || '/';
        const match = path.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
        if (!match) return '';
        // Sanity: only treat as locale if it's not a known top-level Shopify path
        const reserved = ['products', 'collections', 'pages', 'blogs', 'cart', 'account', 'search', 'apps', 'tools', 'a', 'community', 'policies'];
        if (reserved.includes(match[1].toLowerCase())) return '';
        return '/' + match[1];
      }

      // Build a cart URL that respects the current page locale.
      // If routes.cart_url already has a locale prefix we keep it,
      // otherwise we prepend the URL prefix so /lv/products/... → /lv/cart.
      getLocalizedCartUrl() {
        const baseCartUrl = (window.routes && window.routes.cart_url) || '/cart';
        const localePrefix = this.getLocalePrefix();
        if (!localePrefix) return baseCartUrl;
        // If the baseCartUrl already starts with the locale prefix, return as-is
        if (baseCartUrl.startsWith(localePrefix + '/') || baseCartUrl === localePrefix) {
          return baseCartUrl;
        }
        // Prepend the locale prefix
        return localePrefix + baseCartUrl;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Force the cart-add fetch to the locale-prefixed URL so Shopify
        // resolves the correct language for section rendering, regardless
        // of the user's locale cookie state.
        const localePrefix = this.getLocalePrefix();
        const baseCartAdd = (window.routes && window.routes.cart_add_url) || '/cart/add';
        let cartAddUrl = baseCartAdd;
        if (localePrefix && !baseCartAdd.startsWith(localePrefix + '/')) {
          cartAddUrl = localePrefix + baseCartAdd;
        }

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Redirect to cart page in the same language as the current page
              window.location = this.getLocalizedCartUrl();
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}